import { render, staticRenderFns } from "./VacancyMessageArea.vue?vue&type=template&id=e036a8a4&scoped=true"
import script from "./VacancyMessageArea.vue?vue&type=script&lang=js"
export * from "./VacancyMessageArea.vue?vue&type=script&lang=js"
import style0 from "./VacancyMessageArea.vue?vue&type=style&index=0&id=e036a8a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e036a8a4",
  null
  
)

export default component.exports